export default {
  linkedBankAccounts: {
    error: null,
    data: [],
    loading: false,
  },
  linkBankAccountRequest: {
    error: null,
    success: false,
    loading: false,
  },
  selfLinkBankAccount: {
    error: null,
    success: false,
    loading: false,
  },
  linkBankAccount: {
    error: null,
    success: false,
    loading: false,
  },
  bankList: {
    error: null,
    loading: false,
    data: [],
  },
  unlinkAccount: {
    error: null,
    loading: false,
    success: false,
  },
  sendMoneyToBankAccount: {
    error: null,
    loading: false,
    success: false,
  },
  addMoneyToWallet: {
    error: null,
    loading: false,
    success: false,
  },
};
